module.exports = __webpack_public_path__ + "static/rich-hickey-c75808abdc2e3705f9ffc11c427beb33.png";